export const environment = {
  production: false,
  apiHost: 'https://uat.svayamtech.com',
  apiPort: 3004,
  apiHostDd: 'https://dd.dev.svayamtech.com',
  apiPortDd: 3000,
  socketPort: 3002,
  loginWithPassword: true,
  workflow: false,
  log: true,
  public_host: "http://localhost:4800",
  gateway: 'dummy',
  gatewayurl: 'https://test.payu.in/_payment',
  components: [
    "*"
  ],
  auth_validation: {
    'E-KEY': true,
    'P-KEY': true,
    'GOA': true,
    'OTP': false,
    'org_allowed':false
  },

  hostApp: [
    {
      name: 'appdesigner',
      host: 'http://appdesigner.svayamtech.com',
      fpath: 'home',
    },
    {
      name: 'svmai',
      host: 'http://localhost',
      fpath_noAcct: 'login',
      fpath_withAcct: 'all-apps',
      
    },

  ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

